import Rails from '@rails/ujs';

Rails.start();

require('./javascripts/autocomplete');
require('./javascripts/consent');
require('./javascripts/growth_metrics');

// navbar scripts
document.addEventListener('DOMContentLoaded', function () {
    const btn = document.querySelector('button.mobile-menu-button');
    const menu = document.querySelector('#menu');
    const btn_svg_on = document.querySelector('button.mobile-menu-button svg.mobile-svg-on');
    const btn_svg_off = document.querySelector('button.mobile-menu-button svg.mobile-svg-off');
    const navParents = Array.from(document.querySelectorAll('nav li.parent'));

    if (btn !== null) {
        btn.addEventListener('click', () => {
            menu.classList.toggle('hidden');
            btn_svg_on.classList.toggle('hidden');
            btn_svg_off.classList.toggle('hidden');
            btn.setAttribute('aria-expanded', menu.classList.contains('hidden') ? 'false' : 'true');
        });
    }

    const triggerFor = (item) => item.querySelector('a.level1');
    const closeItem = (item) => {
        item.classList.remove('hover');
        const trigger = triggerFor(item);
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
    };

    const openItem = (item) => {
        navParents.forEach((parent) => {
            if (parent !== item) {
                closeItem(parent);
            }
        });
        item.classList.add('hover');
        const trigger = triggerFor(item);
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
        }
    };

    navParents.forEach((item) => {
        const trigger = triggerFor(item);

        if (!trigger) {
            return;
        }

        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');

        trigger.addEventListener('click', (event) => {
            event.preventDefault();

            if (item.classList.contains('hover')) {
                closeItem(item);
            } else {
                openItem(item);
            }
        });

        trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                if (item.classList.contains('hover')) {
                    closeItem(item);
                } else {
                    openItem(item);
                }
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                openItem(item);
                const firstChildLink = item.querySelector('ul.child a');
                if (firstChildLink) {
                    firstChildLink.focus();
                }
            }
        });

        item.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeItem(item);
                trigger.focus();
            }
        });

        item.querySelectorAll('ul.child a').forEach((childLink) => {
            childLink.addEventListener('click', () => {
                navParents.forEach(closeItem);
            });
        });
    });

    document.addEventListener('click', (event) => {
        if (event.target.closest('nav')) {
            return;
        }

        navParents.forEach(closeItem);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            navParents.forEach(closeItem);
        }
    });
});
